// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"ob_v4OYa8","pageSubtitle":"ob_VTT4qL"};